import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { ConnectedUserContext } from '../connectedUser-context';
import LocationEditModal from './locations/LocationEditModal';

//const cstTableHeaders = ['Name', 'Address', 'Tel', 'Surfaces Types / Nb'];
const cstDefaultSortOrder = ['asc', 'asc', 'asc', 'asc'];
const cstDefaultSortFieldIdx = 1;
const cstLocIdColIdx = 4;
const cstGoogleMapLinkColIdx = 5;

const TABLE_NBCOL = 7;

class AdminLocations extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			locationsData: [],

      sortParams: {
				sortFieldIdx: cstDefaultSortFieldIdx,
				sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
				sortClass: []
			},

			modalLocation: {
				_id: '0',
				name: '',
				address: '',
				tel: '',
				googlemap: '',
				surfaces: []
			},

			showLocationEditModal: false,
			loading: true,
		};

    this.handleSortTable = this.handleSortTable.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
		this.createTableRow = this.createTableRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
    this.reloadData = this.reloadData.bind(this);
	}

	componentDidMount() {
		//console.log('AdminLocations: componentDidMount');
		this.loadData(true);
	}

	loadData(resetSorting) {
		Axios.get('/api/locations/').then(response => {
			var locations = response.data;
			this.buildLocationsTable(locations, resetSorting);
		});	
	}

	buildLocationsTable(locations, resetSorting) {
		var locationsData = [];
		locations.forEach((loc, locIdx) => {

			var locationRow = [];
	  	var locSurfaces = '';
	  	loc.surfaces.forEach(ls => {
	  		locSurfaces += ((locSurfaces.length !== 0) ? ', ' : '') + 
	  			ls.type + ' (' + ls.nb + ')';
	  	});

	  	// <td><a href={loc.googlemap} target="_blank">{loc.googlemap}</a></td>

			locationRow.push(loc.name);
			locationRow.push(loc.address);
			locationRow.push(loc.tel);
			locationRow.push(locSurfaces);
			locationRow.push(loc._id);				// hide
			locationRow.push(loc.googlemap);	// hide (used for hyperlink)

			locationsData.push(locationRow);
		});

		var sortParams = this.state.sortParams;

		if (resetSorting)	{
			sortParams = {
				sortFieldIdx: cstDefaultSortFieldIdx,
				sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
				sortClass: []
			};
		};

		this.sortLocationsData(locationsData, sortParams);
	}

	sortLocationsData(locationsData, sortParams) {

		if (locationsData.length !== 0) {
			var sortSign = 1;
			if (sortParams.sortOrder === 'desc') { 
				sortSign = -1; 
			}

			locationsData.sort((a, b) => {

				var valueA = 0;
				var valueB = 0;
				var compVal = 0;
				var fact1 = 0;
				var defFact = 0;

				// Criteria #1
				valueA = a[sortParams.sortFieldIdx];
				valueB = b[sortParams.sortFieldIdx];

				switch (typeof valueA) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
						break;
			    case "string":
			    	// test if string is numeric
			    	if (this.isNumeric(valueA) && this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
			    	} else {
							compVal = valueA.localeCompare(valueB);
						}
						break;
			    case "number":
						compVal = valueA - valueB;
						break;
			    default:
						compVal = 0;
						break;
				}

				fact1 = (sortSign * compVal);
				defFact = a[0].localeCompare(b[0]);

				// Results
				if (fact1 !== 0) {
					return fact1;
				} else {
					return defFact;
				}
			});
		}

		this.setState({
			locationsData: locationsData,
			sortParams: sortParams,
			loading: false
		});
	}

	reloadData() {
		this.loadData(false);
	}

	render() {
		//console.log('ADMIN_Locations: RENDER');
		//console.log(this.state.locationsData)
		const { connectedUser } = this.context;

		// ADMIN LEVEL REQUESTED:  00-MASTER
		if (connectedUser.isMasterAdmin) {
			return (
				<div>

				<div className="row">
        <div className="col-12">
        	<h5>LIEUX</h5>
				</div>
				</div>

				{(this.state.loading) ?
					this.displaySpinner() : 
					this.displayData()
				}

				<br/><br/><br/>

				{/* Modal */}

				<LocationEditModal 
					className = {this.props.className}
					showModal = {this.state.showLocationEditModal}
					modalLocation = {this.state.modalLocation}
					handleModalCancel = {this.handleModalCancel}
					reloadData = {this.reloadData}
				/>

				</div>
			);

		} else {
			return (
				<div className="col-md-9">
					<p>Vous n'avez pas accès à cette section</p>
				</div>
			);
		}
	}

	displayData() {
		var sortClass = this.state.sortParams.sortClass;
		// console.log('displayData, sortClass')
		// console.log(sortClass)
		return (
			<div>
			<div className="row">
      <div className="col-12">
      	<p>Cliquer sur l'adresse pour ouvrir la carte Google</p>
			</div>
			</div>

			<div className="row">
			<div className="col-12">
			<button className="btn btn-sm btn-primary btn-margin-topbottom-10 btn-extra-padding" 
				onClick={this.handleAddEditLocationClick.bind(this, "NEW LOC")}>
				Nouveau lieu
			</button>
			</div>
			</div>

			<div className="table-responsive">
			<table className="table table-hover table-sm">
			<thead>
				<tr>
					<th></th>
					<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable} width="20%"> Nom	</th>
					<th id='hdr.1' className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable} width="30%"> Adresse	</th>
					<th id='hdr.2' className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable} width="10%"> Téléphone </th>
					<th id='hdr.3' className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable} > Surfaces Type/Nb </th>
					<th></th>
				</tr>
			</thead>

			{this.displayTable()}
			</table>

			</div>
			</div>
		);
	}

	displayTable() {
		if (this.state.locationsData.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun lieu</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.locationsData.map(this.createTableRow)}
				</tbody>
			)
		}
	}

  createTableRow(loc, locIdx) {
  	var trClass = "stateloListItemPointer ";
    return (
      <tr key={'loc.' + locIdx} onDoubleClick={this.handleAddEditLocationClick.bind(this, loc)} className={trClass}>
				<td><input name={'edit.' + locIdx} type="button" onClick={this.handleAddEditLocationClick.bind(this, loc)} value="Éditer"/></td>
				{loc.map(this.createDataCell.bind(this, locIdx))}
				<td><input name={'del.' + locIdx} type="button" onClick={this.handleDeleteLocationClick.bind(this, loc)} value="Supprimer"/></td>
      </tr>
    );
  }

	createDataCell(locIdx, dataCell, dataCellIdx) {
		// Hide location _id
		if (dataCellIdx >= cstLocIdColIdx) {
			return;
		}

		// Address
		if (dataCellIdx === 1) {
			var googlemapLink = this.state.locationsData[locIdx][cstGoogleMapLinkColIdx];
			return (
				<td key={"tdcell." + dataCellIdx}> <a href={googlemapLink} target="_blank"> {dataCell} </a></td>
			);
		}

		// Tel
		if (dataCellIdx === 2) {
			return (
				<td key={"tdcell." + dataCellIdx}> <a href={"tel:"+ dataCell}> {dataCell} </a></td>
			);
		}

		return (
			<td key={"tdcell." + dataCellIdx}>{dataCell}</td>
		);
	}

	handleAddEditLocationClick(locItem) {
	 	//console.log('handleAddEditLocationClick');
	 	//console.log(locItem)

		// new location ?
		var modalLocation = {};
		if (locItem === "NEW LOC") {

			// add location
			modalLocation = {
				_id: '0',
				name: '',
				address: '',
				tel: '',
				googlemap: '',
				surfaces: []
			};
			this.setState({
				modalLocation: modalLocation,
				showLocationEditModal: true
			});

		} else {
			// edit location
			modalLocation = JSON.parse(JSON.stringify(locItem));
			
			modalLocation = {
				_id: locItem[cstLocIdColIdx],
				name: locItem[0],
				address: locItem[1],
				tel: locItem[2],
				surfaces: locItem[3],
				googlemap: locItem[cstGoogleMapLinkColIdx]
			};

			this.setState({
				modalLocation: modalLocation,
				showLocationEditModal: true
			});
		}
	}

	handleDeleteLocationClick(locItem) {
		var confirmAns = window.confirm("Voulez-vous vraiment supprimer la location suivante: \n" + 
			"name: " + locItem[0] + "\n" + "address: " + locItem[1] );
	
		if (confirmAns) {
			// Save to DB
			Axios.delete('/api/locations/' + locItem[cstLocIdColIdx])
			.then(response => {
			 	this.reloadData();
			})
			.catch(error => {
				console.log(error);
			});     
		}

	}

	handleSortTable(e) {
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortOrder = this.state.sortParams.sortOrder;
		var sortFieldIdx = this.state.sortParams.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[colIdx];
		}

		var sortClass = [];
		for(var i = 0; i < (TABLE_NBCOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		var sortParams = {
			sortFieldIdx: colIdx,
			sortOrder: sortOrder,
			sortClass: sortClass
		};

		this.sortLocationsData(this.state.locationsData, sortParams);
	}

	handleModalCancel() {
		this.setState({ 
			showLocationEditModal: false
		});
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	// isNumeric function in javascript
	isNumeric(n) {
  	return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default AdminLocations;
